import { CrudMode, FormItem, SelectsOptions } from '@ohpen/enso-ui';
import { FieldType } from '@pmp/api';
import { t } from 'i18next';

export const getLenderFormSchema = (mode?: CrudMode | null): FormItem[] => [
  {
    title: 'lender.lender.labels.lenderName',
    dataIndex: ['name'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.addressName',
    dataIndex: ['address', 'name'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.numberOrBuilding',
    dataIndex: ['address', 'numberOrBuilding'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.postCode',
    dataIndex: ['address', 'postCode'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.city',
    dataIndex: ['address', 'city'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.country',
    dataIndex: ['address', 'country'],
    formItemProps: {
      required: true,
    },
    fieldProps: {
      disabled: mode === CrudMode.VIEW,
    },
  },
];

export const getLenderProcurationFeesFormSchema = (selectsOptions: SelectsOptions, mode?: CrudMode | null): FormItem[] => [
  {
    title: 'lender.lender.labels.id',
    dataIndex: 'id',
    formItemProps: {
      hidden: mode === CrudMode.CREATE,
    },
    fieldProps: {
      disabled: true,
    },
  },
  {
    title: 'lender.lender.labels.order',
    dataIndex: 'index',
    tooltip: t('lender.lender.labels.orderInfo'),
    fieldProps: {
      disabled: true,
    },
  },
  {
    title: 'lender.lender.labels.procurationFeeRule',
    dataIndex: 'procurationFeeRuleId',
    valueType: 'select',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      optionFilterProp: 'label',
      showSearch: true,
      options: selectsOptions[FieldType.PROCURATION_FEE_RULES],
      disabled: mode === CrudMode.VIEW,
    },
  },
  {
    title: 'lender.lender.labels.procurationFee',
    dataIndex: 'procurationFeeId',
    valueType: 'select',
    formItemProps: {
      required: true,
    },
    fieldProps: {
      optionFilterProp: 'label',
      showSearch: true,
      options: selectsOptions[FieldType.PROCURATION_FEES],
      disabled: mode === CrudMode.VIEW,
    },
  },
];
